import React from 'react';
import {getCapitalized} from '../../utils';
import {Layout} from '../layout';
import {Text} from '../text';

type Props = {
  title: string;
};

export const DayHeader: React.FC<Props> = ({title}) => {
  return (
    <Layout>
      <Text variant="inline_12_default" align="center">
        {getCapitalized(title)}
      </Text>
    </Layout>
  );
};
